(function () {

  // ── Contextual cart recommendation ────────────────────────────────────────
  var TOOLKIT = {
    title: 'TOOLKIT EN MICRORINGEN',
    price: '39,00',
    compare: null,
    url: '/products/volumize-extend-tools',
    image: 'https://cdn.shopify.com/s/files/1/0625/2373/6241/files/Tools_op_doos.png?v=1747842732'
  };

  var VOLUMIZER_CLIP = {
    title: 'VOLUMIZER CLIP',
    price: '17,95',
    compare: null,
    url: '/products/volume-hair-styling-root-lift-clip',
    image: 'https://cdn.shopify.com/s/files/1/0625/2373/6241/files/395c53c1-fc7b-46c5-af87-b23f1ddfdc23.jpg?v=1790445035'
  };

  function isMicroRingWeft(item) {
    var searchable = [item.handle, item.product_title, item.product_type, item.url]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return searchable.indexOf('micro-ring') !== -1 || searchable.indexOf('microring') !== -1;
  }

  function renderRecommendation(el, product) {
    var html = '<h3 class="cart-also-bought__title">People also bought</h3>'
      + '<div class="cart-also-bought__list">'
      + '<div class="cart-rec">'
      + '<img src="' + product.image + '&width=120" alt="' + product.title + '" class="cart-rec__img" loading="lazy">'
      + '<div class="cart-rec__info">'
      + '<span class="cart-rec__title">' + product.title + '</span>'
      + '<span class="cart-rec__price">€' + product.price + '</span>'
      + '</div>'
      + '<a href="' + product.url + '" class="button cart-rec__btn">TOEVOEGEN +</a>'
      + '</div>'
      + '</div>';

    el.innerHTML = html;
  }

  function loadCartRecs() {
    var el = document.getElementById('ve-cart-recs');
    if (!el || el.dataset.loaded) return;
    el.dataset.loaded = 'true';

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var hasMicroRingWeft = items.some(isMicroRingWeft);
        var product = hasMicroRingWeft ? TOOLKIT : VOLUMIZER_CLIP;
        var recommendationAlreadyInCart = items.some(function (item) {
          return product.url.indexOf('/products/' + item.handle) !== -1;
        });

        if (recommendationAlreadyInCart) {
          el.innerHTML = '';
          return;
        }

        renderRecommendation(el, product);
      })
      .catch(function () {
        delete el.dataset.loaded;
        el.innerHTML = '';
      });
  }

  function collapseCartNote() {
    // Close the cart note details accordion by default
    var details = document.querySelector('.cart-drawer .cart-note details[open]');
    if (details) details.removeAttribute('open');
  }

  function init() {
    loadCartRecs();
    setTimeout(collapseCartNote, 100);
  }

  // Re-init when cart drawer opens (cart icon click or auto-open after ATC)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-testid="cart-drawer-trigger"]');
    if (trigger) setTimeout(init, 200);
  });

  // Watch for cart dialog open AND content changes (item remove triggers AJAX refresh)
  function watchCartDialog() {
    var dialog = document.querySelector('[data-testid="cart-drawer-dialog"]');
    if (!dialog) return;

    // Watch for dialog open attribute
    var attrObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open' && dialog.hasAttribute('open')) {
          var recs = document.getElementById('ve-cart-recs');
          if (recs) delete recs.dataset.loaded;
          setTimeout(init, 250);
        }
      });
    });
    attrObserver.observe(dialog, { attributes: true });

    // Watch for cart content being replaced (item remove/add AJAX refresh)
    var contentObserver = new MutationObserver(function () {
      var recs = document.getElementById('ve-cart-recs');
      if (recs && !recs.dataset.loaded) {
        setTimeout(init, 100);
      }
    });
    contentObserver.observe(dialog, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', watchCartDialog);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
